import React from 'react';
import { useInView } from '../../hooks';
import { leadershipTeam } from '../../data/team';

const TeamSection = () => {
  const [ref, isInView] = useInView(0.1);

  return (
    <section
      id="team"
      className="py-24 bg-gradient-to-b from-transparent via-secondary-400/5 to-transparent"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="section-subtitle text-secondary-400">THE DREAMERS</p>
          <h2 className="section-title">
            MEET THE <span className="text-gradient">TEAM</span>
          </h2>
          <p className="section-description">
            The passionate minds behind Riven Byte's African gaming revolution
          </p>
        </div>

        <div
          ref={ref}
          className={`grid grid-cols-2 lg:grid-cols-4 gap-8 transition-all duration-1000 ${
            isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {leadershipTeam.map((member, i) => (
            <div
              key={member.id}
              className="card-hover text-center p-8 bg-white/5 rounded-3xl border border-white/10 group"
              style={{ animationDelay: `${i * 100}ms` }}
            >
              <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-gradient-to-br from-primary-500/20 to-secondary-400/20 flex items-center justify-center text-5xl group-hover:scale-110 transition-transform">
                {member.avatar}
              </div>
              <h3 className="font-bold text-lg mb-1 group-hover:text-primary-500 transition-colors">
                {member.name}
              </h3>
              <p className="text-secondary-400 text-sm">{member.role}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
